import React from 'react';
import { Link } from 'react-router-dom';

const Donate = () => {
    return (
        <div className="container mt-5">
            {/* Two-Column Layout */}
            <div className="row align-items-center mb-5">
                {/* Content Column */}
                <div className="col-lg-6">
                    <h2 className='fw-bold text-center mb-3'>Support Jessster</h2>
                    <p>
                    Jessster exists to make the internet a little more enjoyable — through funny, thoughtful writing that doesn’t take itself too seriously.
                    </p>
                    <p>
                    There’s no paywall, no ads chasing your attention, and no content written just to please an algorithm. Jessster is built around the idea that good humor and honest writing are worth supporting on their own.
                    </p>
                    <p>
                    If you’ve enjoyed reading Jessster — whether a post made you laugh, think, or just distracted you at the right moment — you can support the platform with a contribution.
                    </p>
                    <p>
                    Your support helps:
                    </p>
                    <p>
                    - Keep Jessster running smoothly.
                    </p>
                    <p>
                    - Create more original, well-crafted posts.
                    </p>
                    <p>
                    - Maintain a space where humor comes first.
                    </p>
                    <p>
                    Contributions are entirely optional, but always appreciated.
                    </p>
                     <p>
                    Thanks for being here — and for supporting Jessster in whatever way you choose.
                    </p>
                    {/*
                    <Link to="/" className="btn btn-primary btn-lg">
                        Learn More
                    </Link>
                    */}
                </div>

                {/* Image Column */}
                <div className="col-lg-6 text-center">
                    <img
                        src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736005518/task_management___balance_balancing_unicycle_shapes_woman_people_tasks_gw2fm2.png"
                        alt="Donate to Us"
                        className="img-fluid"
                        style={{ width: '80%', maxWidth: '400px', height: 'auto', borderRadius: '10px' }}
                    />
                </div>
            </div>

            {/* Donation Options Grid */}
            <div className="row text-center">

                {/* Option 2 */}
                <div className="col-md-3 mb-4">
                    <div className="card p-3">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736066914/Frame_427318907_kdbzpr.png"
                            alt="Buy Me a Coffee"
                            className="img-fluid mb-3"
                        />
                        <h5 className='fw-bold'>Buy Me a Coffee</h5>
                        <Link to="https://buymeacoffee.com/jessster" className="btn btn-warning fw-bold p-3">
                            Buy a Coffee
                        </Link>
                    </div>
                </div>

                {/* Option 1 */}
                <div className="col-md-3 mb-4">
                    <div className="card p-3">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736066921/Frame_427318908_knlxqs.png"
                            alt="PayPal"
                            className="img-fluid mb-3"
                        />
                        <h5 className='fw-bold'>PayPal</h5>
                        <Link to="https://www.paypal.com/donate/?hosted_button_id=3NX5AKJAXEM3U" className="btn btn-primary fw-bold p-3">
                            Donate via PayPal
                        </Link>
                    </div>
                </div>


                {/* Option 3 */}
                <div className="col-md-3 mb-4">
                    <div className="card p-3">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736066914/Frame_427318909_vrnfe3.png"
                            alt="Ko-fi"
                            className="img-fluid mb-3"
                        />
                        <h5 className='fw-bold'>Ko-fi</h5>
                        <Link to="https://ko-fi.com/jessster" className="btn btn-secondary fw-bold p-3">
                            Donate on Ko-fi
                        </Link>
                    </div>
                </div>

                {/* Option 4 */}
                <div className="col-md-3 mb-4">
                    <div className="card p-3">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736074494/Frame_427318911_flwyfj.png"
                            alt="Stripe"
                            className="img-fluid mb-3"
                        />
                        <h5 className='fw-bold'>Stripe</h5>
                        <Link to="https://buy.stripe.com/8wM02UaVNaw5e0U288" className="btn fw-bold p-3"
                        style={{
                            backgroundColor: '#685cfc', // Custom background color
                            color: '#ffffff',           // Custom text color
                            border: 'none',             // Optional: Remove border
                            padding: '10px 20px',       // Optional: Adjust padding
                            borderRadius: '5px',        // Optional: Add rounded corners
                            textDecoration: 'none',     // Optional: Ensure link looks like a button
                            display: 'inline-block',    // Optional: Maintain inline-block behavior
                            transition: 'all 0.3s ease' // Optional: Add smooth hover effect
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#5032B5'} // Hover effect
                        onMouseOut={(e) => e.target.style.backgroundColor = '#685cfc'}
                        >
                            Donate via Stripe
                        </Link>
                    </div>
                </div>

                {/* Option 5 
                <div className="col-md-4 mb-4">
                    <div className="card p-3">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736076187/sssd_ewpmoh.png"
                            alt="Crypto"
                            className="img-fluid mb-3"
                        />
                        <h5 className='fw-bold'>Coinbase</h5>
                        <Link to="https://www.coinbase.com/en-gb" className="btn btn-primary fw-bold p-3">
                            Donate Crypto
                        </Link>
                    </div>
                </div>
                */}

                {/* Option 6 
                <div className="col-md-4 mb-4">
                    <div className="card p-3">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736075738/Frame_427318912_rj78dj.png"
                            alt="Other"
                            className="img-fluid mb-3"
                        />
                        <h5 className='fw-bold'>Patreon</h5>
                        <Link to="https://www.patreon.com/profile/creators?u=154920752" className="btn fw-bold p-3"
                        style={{
                            backgroundColor: '#ff5733', // Custom background color
                            color: '#ffffff',           // Custom text color
                            border: 'none',             // Optional: Remove border
                            padding: '10px 20px',       // Optional: Adjust padding
                            borderRadius: '5px',        // Optional: Add rounded corners
                            textDecoration: 'none',     // Optional: Ensure link looks like a button
                            display: 'inline-block',    // Optional: Maintain inline-block behavior
                            transition: 'all 0.3s ease' // Optional: Add smooth hover effect
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#e04e2b'} // Hover effect
                        onMouseOut={(e) => e.target.style.backgroundColor = '#ff5733'}
                        >
                            Support on Patreon
                        </Link>
                    </div>
                </div>
                */}
            </div>
        </div>
    );
};

export default Donate;
